import React, { useState } from "react"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

const PresentAll = ({ modal, toggle, data }) => {
  return (
    <div>
      <Button color="primary" onClick={toggle}>
        Mark All Present
      </Button>

      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Confirm Action</ModalHeader>
        <ModalBody>Do you want to mark all students as present?</ModalBody>
        <ModalFooter>
          <Button color="success" onClick={handleConfirm}>
            Yes
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default PresentAll
